import React from 'react';

function LegalFooter() {
  return (
    <div className="flex justify-center pt-4 px-4 pb-16 uppercase text-foreground-muted text-sm mt-12">
      <span className="pl-2">
        ©{new Date().getFullYear()}
        <a
          href="https://petsafebrands.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="pl-2 text-foreground-muted"
        >
          PetSafe Brands
        </a>
        <span className="pl-2">All Rights Reserved.</span>
        <a
          href="https://www.sportdog.com/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="pl-2 text-foreground-muted"
        >
          Privacy Statement
        </a>
        <a
          href="https://www.sportdog.com/support/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
          className="pl-2 text-foreground-muted"
        >
          Terms &amp; Conditions
        </a>
      </span>
    </div>
  );
}

export default LegalFooter;
